import { Link } from "react-router-dom";
import { categoryMeta, getByType, type VideoType } from "@/mocks/videos";

const ORDER: VideoType[] = ["movie", "tv", "short"];

export default function CategoryQuickEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="mb-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">内容分类</h2>
        <p className="text-sm text-foreground-600 mt-2">三大板块，四万余部作品，按你此刻的心情开始探索</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {ORDER.map((type, idx) => {
          const meta = categoryMeta[type];
          const count = getByType(type).length;
          const isAccent = idx === 0;
          return (
            <Link
              key={type}
              to={`/category/${type}`}
              className={`group relative rounded-lg p-6 md:p-7 overflow-hidden border transition-colors cursor-pointer ${
                isAccent
                  ? "bg-primary-500 border-primary-500 hover:bg-primary-600"
                  : "bg-background-100 border-background-200/80 hover:border-primary-300"
              }`}
            >
              <div
                className={`w-14 h-14 md:w-16 md:h-16 rounded-lg flex items-center justify-center mb-5 ${
                  isAccent ? "bg-background-50/15 text-background-50" : "bg-secondary-100 text-secondary-700"
                }`}
              >
                <i className={`${meta.icon} text-2xl md:text-3xl`} aria-hidden="true"></i>
              </div>
              <h3 className={`font-heading font-bold text-xl mb-2 ${isAccent ? "text-background-50" : "text-foreground-950"}`}>
                {meta.label}
              </h3>
              <p className={`text-sm leading-relaxed line-clamp-2 ${isAccent ? "text-background-100/85" : "text-foreground-600"}`}>
                {meta.intro}
              </p>
              <div className={`mt-5 flex items-center justify-between text-sm ${isAccent ? "text-background-50" : "text-primary-600"}`}>
                <span className="font-medium">{count} 部精选内容</span>
                <span className="flex items-center gap-1 group-hover:translate-x-1 transition-transform">
                  进入 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}